module.exports = __webpack_public_path__ + "img/inflable-success.b3a8a272.svg";